namespace JupitersChoice {
    export class RequestFreeSpinCmd {

        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameServer') _server: Sapphire.GameServer;

        execute(): void {
            const response: any = this._server.logicResponse;
            const hasAnotherFreeSpin = response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx];

            if (undefined === hasAnotherFreeSpin) {
                this._eventManager.publish('onHasNoFreeSpins');
            } else {
                ShowFreeGameCmd.currentFreeGameSpinIdx++;
                this._eventManager.publish('onHasFreeSpins');
            }
        }
    }
}